module.exports = __webpack_public_path__ + "static/media/malta.d6abe07e.png";